export default __webpack_public_path__ + "static/media/amazon.c1549c15.svg";